module.exports = __webpack_public_path__ + "img/202405_05.cf605f08.jpg";